// Fuel grade color coding utility
// Used across the application for consistent fuel type visualization

export const getFuelGradeColor = (gradeName) => {
  const name = (gradeName || '').toLowerCase();
  
  // Diesel variants - Blue shades
  if (name.includes('diesel') || name.includes('derv')) {
    if (name.includes('super') || name.includes('premium') || name.includes('ultimate') || name.includes('v-power')) {
      return { bg: 'bg-blue-600', text: 'text-white', border: 'border-blue-600', badge: 'bg-blue-600 text-white' };
    }
    return { bg: 'bg-blue-500', text: 'text-white', border: 'border-blue-500', badge: 'bg-blue-500 text-white' };
  }
  
  // Petrol/Unleaded variants - Green shades
  if (name.includes('petrol') || name.includes('unleaded') || name.includes('e10') || name.includes('e5')) {
    if (name.includes('super') || name.includes('premium') || name.includes('ultimate') || name.includes('v-power') || name.includes('99') || name.includes('97')) {
      return { bg: 'bg-emerald-600', text: 'text-white', border: 'border-emerald-600', badge: 'bg-emerald-600 text-white' };
    }
    return { bg: 'bg-green-500', text: 'text-white', border: 'border-green-500', badge: 'bg-green-500 text-white' };
  }
  
  // Adblue - Light blue
  if (name.includes('adblue') || name.includes('def')) {
    return { bg: 'bg-cyan-400', text: 'text-slate-900', border: 'border-cyan-400', badge: 'bg-cyan-400 text-slate-900' };
  }
  
  // LPG/Autogas - Purple
  if (name.includes('lpg') || name.includes('autogas')) {
    return { bg: 'bg-purple-500', text: 'text-white', border: 'border-purple-500', badge: 'bg-purple-500 text-white' };
  }
  
  // Default - Amber (fuel-like)
  return { bg: 'bg-amber-500', text: 'text-white', border: 'border-amber-500', badge: 'bg-amber-500 text-white' };
};
